/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Select_All_EventsInputs */

const en_shortcut_keys_desc_select_all_events = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select all events in event group`)
};

const fr_shortcut_keys_desc_select_all_events = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner tous les evenements du groupe`)
};

const de_shortcut_keys_desc_select_all_events = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie alle Ereignisse in der Ereignisgruppe aus`)
};

const it_shortcut_keys_desc_select_all_events = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona tutti gli eventi nel gruppo di eventi`)
};

const ru_shortcut_keys_desc_select_all_events = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите все события в группе событий`)
};

const es_shortcut_keys_desc_select_all_events = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar todos los eventos en el grupo de eventos`)
};

const zh_cn2_shortcut_keys_desc_select_all_events = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择事件组中的所有事件`)
};

const ja_shortcut_keys_desc_select_all_events = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントグループ内のすべてのイベントを選択`)
};

const hi_shortcut_keys_desc_select_all_events = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट समूह में सभी इवेंट चुनें`)
};

const pt_pt2_shortcut_keys_desc_select_all_events = /** @type {(inputs: Shortcut_Keys_Desc_Select_All_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione todos os eventos no grupo de eventos`)
};

/**
* | output |
* | --- |
* | "Select all events in event group" |
*
* @param {Shortcut_Keys_Desc_Select_All_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_select_all_events = /** @type {((inputs?: Shortcut_Keys_Desc_Select_All_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Select_All_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_select_all_events(inputs)
	if (locale === "de") return de_shortcut_keys_desc_select_all_events(inputs)
	if (locale === "it") return it_shortcut_keys_desc_select_all_events(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_select_all_events(inputs)
	if (locale === "es") return es_shortcut_keys_desc_select_all_events(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_select_all_events(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_select_all_events(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_select_all_events(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_select_all_events(inputs)
	return en_shortcut_keys_desc_select_all_events(inputs)
});